import React from 'react'
import CapabilityLang from './capabilityLang'
import GeneralCapability from './generalCapability'
import CapabilityDriving from './capabilityDriving'

const Capability = ({ props }) => {
    return (
        <>
            <div className="capability content-block p-3">
                <div className="block-title">ความสามารถ</div>
                <div className='py-2'>
                    <CapabilityLang props={props} />
                </div>
                <div className='py-2'>
                    <GeneralCapability props={props} />
                </div>
                <div className='py-2'>
                    <CapabilityDriving props={props} />
                </div>
            </div>
        </>
    )
}

export default Capability